import { Typography } from '@atlas-metrics/design-system';
import { useTranslation } from 'next-i18next';

import AtlasFooterLink from './AtlasFooterLink';
import { ExternalButtonLink } from '../ui/buttons';
import HorizontalDivider from '../ui/HorizontalDivider';
import Icon from '../ui/Icon';
import { Content } from '../ui/layout';

const AtlasFooter: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className='w-full bg-ds-grey-950 text-ds-grey-600 shadow-floating'>
      <Content centered type='header' className='flex flex-col'>
        <div className='flex h-full items-center justify-between pb-6 pt-8'>
          <Icon
            name='icon-atlas-world'
            className='h-6 w-6 text-transparent webS:hidden'
          />
          <Icon
            name='icon-atlas-logo-primary'
            className='hidden h-8 w-[160px] text-transparent webS:!block'
          />
          <ExternalButtonLink
            href='https://www.atlasmetrics.io'
            variant='primary'
            textClassName='text-white'
          >
            {t('atlas-metrics.visit')}
          </ExternalButtonLink>
        </div>
        <HorizontalDivider />
        <Typography
          variant='body-s'
          className='w-[184px] py-6 leading-6 text-ds-grey-600'
        >
          {t('atlas-metrics.tag-line')}
        </Typography>
        <HorizontalDivider />
        <div className='mb-2 flex flex-col webS:flex-row webS:justify-between '>
          <Typography variant='body-s' className='py-6 text-ds-grey-600'>
            {t('atlas-metrics.copyright', { year: new Date().getFullYear() })}
          </Typography>
          <ul className='flex flex-col webS:flex-row webS:gap-4'>
            <li>
              <AtlasFooterLink
                text={t('atlas-metrics.privacy-policy')}
                path='privacy'
              />
            </li>
            <li>
              <AtlasFooterLink
                text={t('atlas-metrics.imprint')}
                path='imprint'
              />
            </li>
          </ul>
        </div>
      </Content>
    </div>
  );
};

export default AtlasFooter;
